import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "./firebase";
import CardService from "../../FrontEnd/Integration/CardService";
import { useMemo } from "react";
import Spinner from "../../FrontEnd/Integration/Spinner";



function FbGetProducctService({ pageSize = 30, currentPage = 1, onTotalChange = () => {} }) {
  const [service, setService] = useState([]);
    const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    async function fetchData() {
      try {
        const parts = location.pathname.split("/");

        if (parts.length < 4) {
          navigate("/Home");
          return;
        }

        const tipo = parts[2];
        const subtype = parts[3];
        const categoriaNome = parts[4]
          ? decodeURIComponent(parts[4])
          : null;

        const pathRef = collection(db, "Db", tipo, subtype);

        let q;

        if (categoriaNome) {
          q = query(pathRef, where("category", "==", categoriaNome));
        } else {
          q = query(pathRef);
        }

        const snap = await getDocs(q);

        if (snap.empty) {
          navigate("/Home");
          return;
        }

        const data = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setService(data);
        onTotalChange(data.length); // **IMPORTANTE**: use o array local, não o estado assíncrono
      setLoading(false);
      } catch (error) {
        console.error("Erro ao buscar serviços:", error);
        navigate("/Home");
      }
    }

    if (location.pathname.length > 10) {
      fetchData();
    }
  },[location.pathname, navigate, onTotalChange]);


    // Cálculo do slice da página atual
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;
  
    const pageItems = useMemo(() => {
      return service.slice(start, end);
    }, [service, start, end]);

  return (
    <>
        {loading && <Spinner />}
  
    <div>
   
      {service.map((prod) => (
        <CardService key={prod.id} {...prod} />
      ))}
    </div>
      </>
  );
}

export default FbGetProducctService;